import Application from "../../Application";
import { ICredentialsService } from "../../service/authentication/CredentialsService";
import { IStore } from "../../model/runtime/state/Store";
import { IUserService } from "../../service/user/UserService";
import { IFormService } from "../../service/form/FormService";
import { AppConstants, MenuItemInsertForm } from "../../common/Constants";
import { IRequestService } from "../../service/request/RequestService";
import { IMenuItemService } from "../../service/menu/MenuItemService";

export default class LoadUserPreferencesInteractor {
  private application: Application;
  private credentialsService: ICredentialsService;
  private userService: IUserService;
  private formService: IFormService;
  private requestService: IRequestService;
  private menuItemService: IMenuItemService;
  private store: IStore;

  constructor(
    application,
    credentialsService,
    userService,
    formService,
    requestService,
    menuItemService,
    store
  ) {
    this.application = application;
    this.credentialsService = credentialsService;
    this.userService = userService;
    this.formService = formService;
    this.requestService = requestService;
    this.menuItemService = menuItemService;
    this.store = store;
  }

  async execute(applicantId?: number) {
    this.credentialsService.setIsLoggedIn(true);
    const user = await this.userService.getUserProfile();
    await this.credentialsService.saveRolesToStorage(user.roles);
    const languageCode = await this.credentialsService.getLanguage();
    languageCode &&
      this.application.container.registerValue("language", languageCode);
    try {
      if (this.application.applicationName === AppConstants.FRONTOFFICE) {
        const _applicantId = applicantId
          ? await Promise.resolve(applicantId)
          : await this.formService.getApplicantId();
        this.credentialsService.setApplicantId(_applicantId);
        const requests = await this.requestService.getRequests(_applicantId);
        this.store.update({ requests });
      }
      if (this.application.applicationName === AppConstants.BACKOFFICE) {
        const boMenuItems = await this.menuItemService.getAllRootMenuItems(
          MenuItemInsertForm.Constants.MIK_BO,
          true
        );
        this.store.update({ boMenuItems });
      }
    } catch (error) {}
    this.store.update({
      user,
      roles: user.roles
    });
  }
}
